import { Pipe, PipeTransform } from '@angular/core';
import { format, setDate } from 'date-fns';

@Pipe({
  standalone: false,
  name: 'priceForDay',
})
export class PriceForDayPipe implements PipeTransform {
  transform(pricingObj: any, dayNumber: any, currentDate: Date): any {
    if (!pricingObj) {
      return '';
    }

    const dateWeWant: Date = setDate(currentDate, dayNumber);
    const dayString = format(dateWeWant, 'YYYY-MM-DD');

    const result = pricingObj[dayString];

    if (result && !result.available) {
      return '';
    }

    if (result && result.price && result.price.display) {
      return result.price.display;
    }
  }
}
